import { render } from "./TextToSpeech.vue?vue&type=template&id=4ae2bfc5&scoped=true"
import script from "./TextToSpeech.vue?vue&type=script&lang=js"
export * from "./TextToSpeech.vue?vue&type=script&lang=js"

import "./TextToSpeech.vue?vue&type=style&index=0&id=4ae2bfc5&scoped=true&lang=css"

import exportComponent from "/root/respina-board/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae2bfc5"]])

export default __exports__